export default `float s=3., offset=8., e;
    for(int i=0;i++<9;p=vec3(2.0,4.0,2.0)-abs(abs(p)*e-vec3(4.0,4.0,2.0)))
      s*=e=max(1.,(8.+offset)/dot(p,p));
    return min(length(p.xz),p.y)/s;
  }`